<template>
  <div>
    <new-generation-dialog :state="createGeneration" />
    <generation-update-dialog :state="editGeneration" :generation="selected" />
    <div class="d-flex justify-space-between align-center pa-4 pa-md-2">
      <div>
        <Breadcrumbs
          headline="Danh sách niên khóa"
          :link="[{ text: 'Danh sách niên khóa', href: '../Generations' }]"
        />
      </div>
      <div>
        <v-btn
          color="primary"
          @click="createGeneration = !createGeneration"
          v-if="canEditGeneration"
          ><v-icon left>add</v-icon>{{ addButtonText }}</v-btn
        >
      </div>
    </div>
    <v-card class="pa-2 mx-md-2">
      <v-data-table
        item-key="id"
        :headers="headers"
        :items="generations"
        sort-by="createdAt"
        :sort-desc="true"
      >
        <template v-slot:[`item.actions`]="{ item }" v-if="canEditGeneration">
          <generation-list-actions :selected="item" @onEdit="onEditGeneration" />
        </template>
        <template v-slot:[`item.is_graduated`]="{ item }">
          <span v-if="!item.is_graduated"> - </span>
          <span class="success--text" v-else> ✓ </span>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Breadcrumbs from '@/components/layout/Breadcrumbs'
import GenerationListActions from '@/modules/generation/GenerationListActions'
import NewGenerationDialog from '@/modules/generation/NewGenerationDialog'
import GenerationUpdateDialog from '@/modules/generation/GenerationUpdateDialog'
export default {
  components: {
    GenerationListActions,
    NewGenerationDialog,
    GenerationUpdateDialog,
    Breadcrumbs
  },
  props: {
    role: String
  },
  data() {
    return {
      headers: [
        { text: 'Tên', value: 'name', align: 'left', sortable: false },
        { text: 'Mã Khóa', value: 'code', align: 'left', sortable: false },
        { text: 'Mô Tả', value: 'description', align: 'left', sortable: false },
        { text: 'Đã tốt nghiệp', value: 'is_graduated', align: 'left', sortable: false },
        { text: 'Hành động', value: 'actions', align: 'left', sortable: false }
      ],
      selected: {},
      draw: false,
      search: '',
      status: null,
      statuses: [
        { text: 'Active', value: 'false' },
        { text: 'Blocked', value: 'true' }
      ],
      range: { from: null, to: null },
      previewUserId: null,
      ready: false,
      generationTableOptions: {},
      editGeneration: false,
      createGeneration: false
    }
  },
  async created() {
    this.fetchGenerations({ department: this.department.id })
  },
  computed: {
    ...mapState('app', ['department']),
    ...mapGetters('generation', ['generations']),
    ...mapGetters('auth', ['role']),
    canEditGeneration() {
      return ['education_manager', 'super_admin'].includes(this.role.type)
    },

    addButtonText() {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs':
        case 'sm':
          return 'Thêm'
        default:
          return 'Thêm niên khóa'
      }
    }
  },
  methods: {
    ...mapActions('generation', ['fetchGenerations']),
    updateDraw(draw) {
      this.draw = draw
    },
    onGenerationSelected(generation) {
      this.setGeneration(generation)
      this.draw = true
    },
    onEditGeneration(selected) {
      this.selected = selected
      this.editGeneration = !this.editGeneration
    }
  }
}
</script>
